import React, { ReactNode } from "react";
import cn from "classnames";
// Assets
import styles from "./KeyValuePair.module.scss";

export interface KeyValuePairProps {
  boxed?: boolean;
  label: string;
  stacked?: boolean;
  unit?: string;
  value?: ReactNode;
}

export const KeyValuePair: React.FC<KeyValuePairProps> = ({ boxed, label, stacked, unit, value }) => {
  const classes = cn(styles.key_value_pair, {
    [styles["key_value_pair--boxed"]]: !!boxed,
    [styles["key_value_pair--stacked"]]: !!stacked,
  });

  return (
    <span className={classes}>
      <span className={styles.key_value_pair__key}>{label}</span>

      {value ? (
        <>
          <span className={styles.key_value_pair__value}>{value}</span>
          {unit && <span className={styles.key_value_pair__unit}>{unit}</span>}
        </>
      ) : (
        <span className={styles.key_value_pair__value}>{"\u2014"}</span>
      )}
    </span>
  );
};
